// extracted by mini-css-extract-plugin
module.exports = {"item":"CustomItem_item__11H7O","button":"CustomItem_button__1oCZ_","delete":"CustomItem_delete__2uUSE"};